import React from 'react';

import Svg from '@bibliocommons/svg';

import Divider from 'app/components/bibs/shared/Divider';

import './BrowseCategoryNodePageLoadingStencil.scss';

const NavItemPlaceholder = () => {
  return (
    <div className="nav-item">
      <Svg className="pulse nav-item-svg">
        <rect height="100%" width="100%" />
      </Svg>
    </div>
  );
};

const BrowseCategoryNodePageLoadingStencil = () => {
  return (
    <article className="cp-browse-category-node-page-loading-stencil container" role="presentation">
      <section className="breadcrumbs">
        <Svg className="pulse breadcrumb-svg">
          <rect height="100%" width="100%" />
        </Svg>
      </section>
      <section className="nav">
        <div className="row">
          <div className="col-md-6">
            <NavItemPlaceholder />
          </div>
          <div className="col-md-6">
            <NavItemPlaceholder />
          </div>
        </div>
        <div className="row nav-row-2">
          <div className="col-md-6">
            <NavItemPlaceholder />
          </div>
          <div className="col-md-6">
            <NavItemPlaceholder />
          </div>
        </div>
      </section>

      <Divider />

      <section className="bibs">
        <div className="title">
          <Svg className="pulse title-svg">
            <rect height="100%" x="0" y="0" width="100%" />
          </Svg>
        </div>

        <ul className="row bib-list">
          {Array.from({ length: 8 }).map(() => {
            return (
              <li className="bib-list-item">
                <div className="bib"></div>
              </li>
            );
          })}
        </ul>
      </section>
    </article>
  );
};

export default BrowseCategoryNodePageLoadingStencil;
